<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './assets/css/reset.scss';
@import './assets/css/layout.scss';
@import './assets/icon/iconfont.scss';
@font-face {
  font-family: ygyxsziti;
  src: url(./assets/font/ygyxsziti2.0.ttf);
}
@font-face {
  font-family: HYBeiWeiXieJingW;
  src: url(./assets/font/HYBeiWeiXieJingW.ttf);
}
@font-face {
  font-family: HYShangWeiShouShuW;
  src: url(./assets/font/HYShangWeiShouShuW.ttf);
}
@font-face {
  font-family: 杨任东竹石体-Bold;
  src: url(./assets/font/杨任东竹石体-Bold.ttf);
}
@font-face {
  font-family: zkklt;
  src: url(./assets/font/站酷快乐体2016修订版.ttf);
}
</style>



// WEBPACK FOOTER //
// src/App.vue